export default __webpack_public_path__ + "static/media/showcase-parenting-2.a391c4bb.jpg";